import React, { useState, useEffect, createContext } from "react";
import { Service } from "./App.Service";

const AppStore = createContext();
const { Provider } = AppStore;

const AppProvider = ({ children }) => {
    const [popupState, setPopup] = useState(-2);
    
    const state = {
        popupState
    };

    const actions = {
        setPopup
    };

    return <Provider value={{ ...state, ...actions }}> {children} </Provider>;
};

export { AppProvider, AppStore };


// WEBPACK FOOTER //
// ./src/Components/App/App.Store.jsx